<template>
  <b-card class="mt-5">
    <b-row>
      <b-col class="col-12">
        <SearchFilter
          @handleSubmit="onHandleSubmit"
          :autoSearch="true"
          :dashboardName="dashboardName"
        />
      </b-col>
    </b-row>
    <!-- ROW 1 : BOX CHART (VERTICAL) + BAR CHART -->
    <b-row class="mt-2">
      <!-- BOX CHART -->
      <b-col cols="12" lg="6">
        <b-row>
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal(
                        'จำนวนเรื่อง Fasttrack ทั้งหมด (เจ้าหน้าที่)',
                        'FASTTRACK_ROLE_OFFICER_ALL_RECEIVE',
                      )
                    "
                  >
                    <h2 class="">{{ total }}</h2>
                    <span class="card-title box-text-size"
                      >จำนวนเรื่อง Fasttrack ทั้งหมด (เจ้าหน้าที่)</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal(
                        'จำนวนเรื่อง Fasttrack ที่ยังอยู่ระหว่างดำเนินการที่บริษัท',
                        'FASTTRACK_ROLE_OFFICER_INCOME_MOU',
                      )
                    "
                  >
                    <h2 class="">{{ totalFromScreening }}</h2>
                    <span class="card-title box-text-size"
                      >จำนวนเรื่อง Fasttrack ที่ยังอยู่ระหว่างดำเนินการที่บริษัท</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal(
                        'จำนวนเรื่องที่เจ้าหน้าที่ส่ง Fasttrack เอง',
                        'FASTTRACK_ROLE_OFFICER_INCOME_MOU_LIST',
                      )
                    "
                  >
                    <h2 class="">{{ totalMySelf }}</h2>
                    <span class="card-title box-text-size"
                      >จำนวนเรื่องที่เจ้าหน้าที่ส่ง Fasttrack เอง</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <!-- BAR CHART -->
      <b-col cols="12" lg="6">
        <ApexDataBarChart
          ref="REF_BAR_FASTTRACK_ROLE_OFFICER_TERMINATE_FROM_FASTTRACK"
          :filter="filter"
          :issueName="'FASTTRACK_ROLE_OFFICER_TERMINATE_FROM_FASTTRACK'"
          :titleText="'จำนวนเรื่อง Fasttrack ดำเนินการยุติแล้วเสร็จ'"
        >
        </ApexDataBarChart>
      </b-col>
    </b-row>
    <!-- ROW 2 : TABLE + TABLE -->
    <b-row class="mt-2">
      <!-- TABLE LEFT -->
      <b-col cols="12" lg="6">
        <div class="card mt-2">
          <div class="card-body">
            <h5 class="mb-2">{{ tableLeftTitle }}</h5>
            <b-table
              striped
              hover
              small
              responsive
              :items="tableLeftItems"
              :fields="tableFields"
              :tbody-tr-class="rowClass"
              @row-clicked="onCompanyRowClicked"
            ></b-table>
          </div>
        </div>
      </b-col>
      <!-- TABLE RIGHT -->
      <b-col cols="12" lg="6">
        <div class="card mt-2">
          <div class="card-body">
            <h5 class="mb-2">{{ tableRightTitle }}</h5>
            <b-table
              striped
              hover
              small
              responsive
              :items="tableRightItems"
              :fields="tableFields"
              :tbody-tr-class="statusRowClass"
              @row-clicked="onStatusRowClicked"
            ></b-table>
          </div>
        </div>
      </b-col>
    </b-row>
    <ModalVue
      @show="openModal"
      ref="REF_REF_FASTTRACK_ROLE_OFFICER_MODAL"
      :filter="filter"
    ></ModalVue>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BLink,
  BCard,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BTable,
} from "bootstrap-vue";

// import flatPickr from "vue-flatpickr-component";
import ApexDataBarChart from "./components/charts/ApexDataBarChart.vue";
import SearchFilter from "./components/SearchFilter.vue";

import * as userData from "@/auth/localStorageUtils.js";
import * as apiDashboard from "@/store/api/dashboard/index.js";
import * as apiUser from "@/store/api/user/index.js";

import ModalVue from "./components/Modal.vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BCardText,
    BTable,
    SearchFilter,
    ApexDataBarChart,
    ModalVue,
  },
  props: {},
  data() {
    return {
      total: 0,
      totalFromScreening: 0,
      totalMySelf: 0,
      // TABLE (PLACEHOLDER DATA - WAITING FOR API)
      tableFields: [
        { key: "name", label: "หัวข้อ" },
        { key: "total", label: "จำนวน", class: "text-right" },
      ],
      tableLeftTitle: "รายการรายชื่อบริษัทพร้อมจำนวนเรื่อง",
      tableLeftItems: [
        { name: "-", total: 0 },
        { name: "-", total: 0 },
        { name: "-", total: 0 },
      ],
      tableRightTitle:
        "สถานะการดำเนินการ",
      tableRightItems: [
        { name: "-", total: 0 },
        { name: "-", total: 0 },
        { name: "-", total: 0 },
      ],
      filter: {
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: userData.userId(),
        departmentId: userData.departmentId(),
        // userId: "E4EB19A4-1F56-40A9-AB09-2382AD0A9D55",
        // departmentId: "ECC7E239-BD06-45A0-BE32-505E002F5D98",
        terminateMode: "officer",
      },
      // dashboardName: `ภาพรวมสถิติการดำเนินการเรื่องร้องทุกข์ของเจ้าหน้าที่ ${userData.fullName()}`,
      dashboardName: `ภาพรวมสถิติการดำเนินการเรื่อง Fasttrack ของเจ้าหน้าที่`,
    };
  },
  mounted() {
    // TEST
    // this.OfficerBoxChartComplaintIncome();
    // this.OfficerChartsComplaintMouIncome();
    // this.$refs.REF_BAR_FASTTRACK_ROLE_OFFICER_TERMINATE_FROM_FASTTRACK.funcOfficerBarChartTerminateFromFasttrack(
    //   this.filter
    // );
  },
  methods: {
    onHandleSubmit(submitFilter) {
      console.log("onHandleSubmit .submitFilter", submitFilter);

      this.filter.startDate = submitFilter.startDate;
      this.filter.endDate = submitFilter.endDate;
      console.log("onHandleSubmit .filter", this.filter);

      this.OfficerBoxChartComplaintIncome(this.filter);
      this.OfficerChartsComplaintMouIncome(this.filter);
      this.OfficerTableChartyComplaintUnderOfficer(this.filter);
      this.$refs.REF_BAR_FASTTRACK_ROLE_OFFICER_TERMINATE_FROM_FASTTRACK.funcOfficerBarChartTerminateFromFasttrack(
        this.filter,
      );
    },
    funcGetUser() {
      const self = this;
      const isAdmin = userData.isAdminRole();
      if (isAdmin === true) {
        // //console.log"@funcGetUser isAdmin", isAdmin);
        apiUser
          .getById(self.filter.userId)
          .then((response) => {
            // //console.log"@funcGetUser response", response);
            if (response.data.data.fullname) {
              self.dashboardName = `${self.dashboardName} ${response.data.data.fullname}`;
            }
          })
          .catch((error) => {
            //console.log"error", error);
          });
        //console.log"@funcGetUser self.dashboardName", self.dashboardName);
      } else {
        self.dashboardName = `${self.dashboardName} ${userData.fullName()}`;
        //console.log"@funcGetUser self.dashboardName", self.dashboardName);
      }
      // //console.log"@funcGetUser", self.filter);
    },
    OfficerBoxChartComplaintIncome() {
      console.log("OfficerBoxChartComplaintIncome .filter", this.filter);

      apiDashboard
        .OfficerBoxChartComplaintIncome(this.filter)
        .then((response) => {
          console.log("OfficerBoxChartComplaintIncome .response", response);
          console.log(
            "OfficerBoxChartComplaintIncome .response.data",
            response.data,
          );

          this.total = response.data.data ?? 0;
        })
        .catch((error) => {
          console.log("OfficerBoxChartComplaintIncome .error", error);
        });
    },
    OfficerChartsComplaintMouIncome() {
      console.log("OfficerChartsComplaintMouIncome .filter", this.filter);

      apiDashboard
        .OfficerChartsComplaintMouIncome(this.filter)
        .then((response) => {
          console.log("OfficerChartsComplaintMouIncome .response", response);
          console.log(
            "OfficerChartsComplaintMouIncome .response.data",
            response.data,
          );

          // Group 100 = ถืออยู่และยังอยู่ระหว่างดำเนินการที่บริษัท (onFastTrack = 1)
          // Group 200 = เจ้าหน้าที่คนนี้กดส่ง Fasttrack (514/518) เอง
          // SP แยกรายบริษัท จึงรวมเป็นตัวเลขกล่อง (1 เรื่องอยู่บริษัทเดียวต่อ group)
          this.totalFromScreening = response.data.data
            .filter((x) => x.group === 100)
            .reduce((sum, x) => sum + x.total, 0);

          this.totalMySelf = response.data.data
            .filter((x) => x.group === 200)
            .reduce((sum, x) => sum + x.total, 0);

          // ตาราง 1 = Group 300 : เรื่องที่ส่ง Fasttrack ทั้งหมด (100 ∪ 200 ไม่นับซ้ำ) แยกรายบริษัท
          // id = CompanyId ใช้ส่งเป็น TargetId ตอน drill-down, null = "(ไม่พบชื่อบริษัท)" กดไม่ได้
          this.tableLeftItems = response.data.data
            .filter((x) => x.group === 300)
            .map((item) => ({
              id: item.id,
              name: item.name,
              total: item.total,
            })) ?? [
            { name: "-", total: 0 },
            { name: "-", total: 0 },
            { name: "-", total: 0 },
          ];

          console.log(
            "OfficerChartsComplaintMouIncome .totalFromScreening",
            this.totalFromScreening,
          );
          console.log(
            "OfficerChartsComplaintMouIncome .totalMySelf",
            this.totalMySelf,
          );
          console.log(
            "OfficerChartsComplaintMouIncome .tableLeftItems",
            this.tableLeftItems,
          );
        })
        .catch((error) => {
          console.log("OfficerChartsComplaintMouIncome .error", error);
        });
    },
    OfficerTableChartyComplaintUnderOfficer() {
      console.log(
        "OfficerTableChartyComplaintUnderOfficer .filter",
        this.filter,
      );

      apiDashboard
        .OfficerTableChartyComplaintUnderOfficer(this.filter)
        .then((response) => {
          console.log(
            "OfficerTableChartyComplaintUnderOfficer .response",
            response,
          );
          console.log(
            "OfficerTableChartyComplaintUnderOfficer .response.data",
            response.data,
          );

          this.tableRightItems = response.data.data.map((item) => ({
            name: item.name,
            total: item.total,
          }));

          console.log(
            "OfficerTableChartyComplaintUnderOfficer .tableRightItems",
            this.tableRightItems,
          );
        })
        .catch((error) => {
          console.log("OfficerTableChartyComplaintUnderOfficer .error", error);
        });
    },
    openModal(title, keyword) {
      console.log("openModal .title", title);
      console.log("openModal .keyword", keyword);

      const target = this.$refs["REF_REF_FASTTRACK_ROLE_OFFICER_MODAL"];
      target.onSetData(title, keyword, this.filter); // send object to child
      target.$refs["REF_FASTTRACK_ROLE_MODAL"].show();
    },
    // แถวที่ไม่มี id (= "(ไม่พบชื่อบริษัท)") กดไม่ได้ ทำให้ดูจางและไม่ขึ้น pointer
    rowClass(item) {
      if (!item) return null;
      return item.id ? "cursor-pointer" : "text-muted";
    },
    // ตาราง 2 ไม่มี id ใช้ชื่อสถานะเป็น key : กดได้เมื่อมีจำนวน (แถว placeholder "-" กดไม่ได้)
    statusRowClass(item) {
      if (!item) return null;
      return item.total > 0 && item.name && item.name !== "-"
        ? "cursor-pointer"
        : "text-muted";
    },
    // drill-down ของตาราง 2 : สถานะจากระบบ Fasttrack -> เรื่องของสถานะนั้น
    onStatusRowClicked(row) {
      if (!row || !(row.total > 0) || !row.name || row.name === "-") return;

      const target = this.$refs["REF_REF_FASTTRACK_ROLE_OFFICER_MODAL"];
      // copy object : ไม่ให้ Mode ค้างอยู่ใน this.filter
      target.onSetData(
        `${this.tableRightTitle} : ${row.name}`,
        "FASTTRACK_ROLE_OFFICER_STATUS",
        {
          ...this.filter,
          Mode: row.name,
        },
      );
      target.$refs["REF_FASTTRACK_ROLE_MODAL"].show();
    },
    // drill-down ของตาราง 1 : รายชื่อบริษัท -> เรื่องที่ส่ง Fasttrack ไปบริษัทนั้น
    onCompanyRowClicked(row) {
      if (!row || !row.id) return;

      const target = this.$refs["REF_REF_FASTTRACK_ROLE_OFFICER_MODAL"];
      // userId / departmentId ติดไปกับ this.filter อยู่แล้ว
      target.onSetData(
        `${this.tableLeftTitle} : ${row.name}`,
        "FASTTRACK_ROLE_OFFICER_COMPANY",
        {
          ...this.filter,
          TargetId: row.id,
        },
      );
      target.$refs["REF_FASTTRACK_ROLE_MODAL"].show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.box-main {
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  height: 150px;
  border-top-style: solid;
  border-top-color: #bfb9f1;
  border-top-width: 20px;
  border-radius: 0;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.box-main:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  background-color: #f8f9fa; /* light gray highlight */
  border-top-color: red;
}
.box-sub {
  background-color: #f8f9fa;
  // background-color: whitesmoke;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.box-text-size {
  font-size: 16px !important;
}

.card-underline {
  // border-bottom-style: solid;
  border-bottom-color: black;
}

/* แถวในตารางที่คลิกเข้า drill-down ได้ */
::v-deep tr.cursor-pointer {
  cursor: pointer;
}
</style>
